import React from "react";
import { Star, Sparkles, ArrowDown } from "lucide-react";

export default function Hero() {
  return (
    <section className="relative overflow-hidden grid-bg pb-24">
      <div className="glow-orb" style={{ width: 500, height: 500, background: "#2fe1c8", top: -150, left: "30%", opacity: 0.18 }} />
      <div className="glow-orb" style={{ width: 420, height: 420, background: "#6dc6ff", top: 120, right: -80, opacity: 0.15 }} />

      <div className="relative z-10 max-w-6xl mx-auto px-6 pt-10 md:pt-16 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#3df3c2]/40 bg-[#3df3c2]/[0.06] text-[#3df3c2] text-xs tracking-wide fade-up">
          <Sparkles className="w-3.5 h-3.5" />
          Mentorship Training — Limited Spots
        </div>

        <h1 className="mt-8 font-black leading-[0.95] tracking-tight text-5xl sm:text-6xl md:text-7xl lg:text-[96px] fade-up delay-1">
          <span className="block text-white">SCALE YOUR INCOME</span>
          <span className="block hero-gradient">WITH WHOLESALE</span>
          <span className="block text-white">REAL ESTATE</span>
        </h1>

        <div className="section-divider my-10" />

        <p className="max-w-2xl mx-auto text-white/65 text-base md:text-lg leading-relaxed fade-up delay-2">
          No license. No credit. No experience needed. My step-by-step mentorship shows you exactly
          how to close wholesale deals and build a{" "}
          <span className="text-white font-semibold">$10K+ per month</span> business from scratch.
        </p>

        <div className="flex items-center justify-center gap-2 mt-6 fade-up delay-2">
          <div className="flex">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-4 h-4 fill-[#FFC83D] text-[#FFC83D]" />
            ))}
          </div>
          <span className="text-white/55 text-sm">2,000+ students already inside</span>
        </div>

        <div className="mt-10 fade-up delay-3 flex flex-col items-center gap-3">
          <a
            href="#plans"
            className="btn-cta inline-flex items-center gap-2 px-8 py-4 rounded-xl text-[15px] font-semibold"
          >
            <Sparkles className="w-4 h-4" />
            <span>View Mentorship Plans</span>
            <ArrowDown className="w-4 h-4 cta-arrow" />
          </a>
          <span className="text-white/45 text-xs">3 options · Instant access · No call required</span>
        </div>
      </div>
    </section>
  );
}
